'use client';

import { useTranslation } from 'react-i18next';

import type { CustomerBlacklistStatus } from '@kit/bookings/utils/customer-blacklist-error';
import { Alert, AlertDescription } from '@kit/ui/alert';

export function CustomerBlockAlert({
  block,
  className,
}: {
  block: CustomerBlacklistStatus | null | undefined;
  className?: string;
}) {
  const { t } = useTranslation('bookings');

  if (!block?.blacklisted) {
    return null;
  }

  return (
    <Alert
      variant="destructive"
      className={className}
      data-test="customer-blocked-alert"
    >
      <AlertDescription className="break-words">
        {block.customerReason
          ? t('bookings:customerBlacklistedWithReason', {
              reason: block.customerReason,
            })
          : t('bookings:customerBlacklisted')}
      </AlertDescription>
    </Alert>
  );
}
